import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  period: {
    '@$': 'focusedRange',
  },
  selection: {
    '{}': {
      name: {
        '++': [
          {
            '@$': 'financialVolume',
          },
          ' Expense by College',
        ],
      },
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  slices: {
                    '@': 'expenseQuery',
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          segmentId: 'org',
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
  },
  subqueries: {
    expenseQuery: {
      sort: {
        by: {
          '+': {
            '@': 'expenses',
          },
        },
        descending: true,
      },
      target: 'ent:!org:!div',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          value: {
            '+': {
              '@': 'expenses',
            },
          },
          onClick: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {
                              entityId: {
                                '@_': 'id',
                              },
                              orgLevel: {
                                '@_': ['child', 'name'],
                              },
                              recordId: {
                                '@.': '!id',
                              },
                              orgEntityId: {
                                '@_': 'id',
                              },
                              orgRecordId: {
                                '@.': '!id',
                              },
                            },
                          },
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        },
      },
      subqueries: {
        expenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            project: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
            },
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!award',
              },
              using: 'project',
              target: 'ent:!awards:!award',
              selection: {
                '@.': '!research_type',
              },
            },
          },
        },
      },
    },
  },
}
